<template>
  <div
    id="modalCreateAttachment"
    class="modal fade"
    tabindex="-1"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Adicionar Anexos</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            &times;
          </button>
        </div>
        <form @submit.prevent="submitFiles">
          <div class="modal-body">
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label>Anexos: <span class="text-danger">*</span></label>
                <input
                  type="file"
                  class="form-control-file"
                  multiple
                  @change="handleFileUploads($event)"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-theme"
              title="Adicionar"
              :disabled="disableButton"
            >
              <span v-if="disableButton">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <span v-else>Adicionar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateAttachmentModal',

  props: {
    registryId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      files: null,
      disableButton: false,
    }
  },

  methods: {
    handleFileUploads(event) {
      this.files = event.target.files
    },

    async submitFiles() {
      if (this.files) {
        this.disableButton = true
        try {
          const formData = new FormData()

          for (let i = 0; i < this.files.length; i += 1) {
            const file = this.files[i]
            formData.append(`anexos[${i}]`, file)
          }

          const response = await this.$store.dispatch('saveAttachment', {
            registryId: this.registryId,
            attachment: formData,
          })

          this.disableButton = false
          window.$('#modalCreateAttachment').modal('hide')
          this.$emit('closeModal', true)
          this.$snotify.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$snotify.warning(error.message, 'Atenção!')
          } else {
            this.$snotify.error(
              'Não foi possível se conectar ao servidor.',
              'Erro!',
            )
          }
        }
      } else {
        this.$snotify.warning('Selecione ao menos um arquivo.', 'Atenção!')
      }
    },
  },

  mounted() {
    window.$('#modalCreateAttachment').modal()
  },
}
</script>
